import { h } from 'preact';

import classnames from 'classnames';
import logo from '../../assets/logo.svg';
import style from './index.css';
import Auth from '../auth';

const Footer = () => (
  <>
    <div class={style.footer}>
      <img src={logo} alt="Play2x" height="38" width="120" />
      <div class={style.text}>
        Погрузитесь в увлекательный мир азартных игр <br />
        Начните играть прямо сейчас и получите бонус при регистрации
      </div>
      <Auth text="Начать играть" className={classnames('button', style.footerBtn)} />
    </div>
    <div className={style.social}>
      <a href='https://twitter.com/vplay2x' rel="noreferrer noopener nofollow" target="_blank">
        <svg className="icon icon-twitter">
          <use xlinkHref="#icon-twitter" />
        </svg>
      </a>
      <a href='https://www.youtube.com/channel/UCkXiAdpMCPBwo842CEkul7A' rel="noreferrer noopener nofollow" target="_blank">
        <svg className="icon icon-youtube">
          <use xlinkHref="#icon-youtube" />
        </svg>
      </a>
      <a href='https://vk.com/vplay2x' rel="noreferrer noopener nofollow" target="_blank">
        <svg className="icon icon-vk">
          <use xlinkHref="#icon-vk" />
        </svg>
      </a>
    </div>
    <div class={style.copyright}>Copyright © {new Date().getFullYear()} Play2x</div>
  </>
);

export default Footer;
